export default __webpack_public_path__ + "fc573cd55bbfced077c1b3f422502c93.png";